import React from 'react';

export default function ZdarButcherCipher() {
    return (
        <React.Fragment>
            <div className="zdar-butcher-cipher">
                <div className="zdar-cipher-text">
                    Seřaď části textu tak, aby dávaly smysl a pak hodně štěstí s luštěním šifry.
                </div>
                <div className="zdar-cipher-text zdar-butcher-cipher-heading" />
                <div className="zdar-cipher-text">
                    <ol>
                        <li>
                            <div>8.</div>
                            <div>
                                Pomohl jsem jim tedy najít koťátku nový domov. Po dalším doplnění tu už písek zůstal.
                            </div>
                        </li>
                        <li>
                            <div>3.</div>
                            <div>Minulou zimu se zde stalo to, že někdo schválně kradl písek na posyp chodníků.</div>
                        </li>
                        <li>
                            <div>6.</div>
                            <div>
                                Už jsem to chtěl vzdát, ale v tom jsem to uviděl. Několik dětí si ten písek bralo s
                                sebou do tašek.
                            </div>
                        </li>
                        <li>
                            <div>1.</div>
                            <div>Možná bych ti měl říct, proč tady v řeznictví vždycky dostanu dobrotu.</div>
                        </li>
                        <li>
                            <div>7.</div>
                            <div>
                                Pronásledoval jsem je a zjistil, že se ho snažili použít jako záchod pro malé koťátko,
                                které zachránili, ale neřekli o tom rodičům.
                            </div>
                        </li>
                        <li>
                            <div>9.</div>
                            <div>
                                Pán tady z řeznictví pochopil, že je to moje zásluha a od té doby mi za to děkuje malými
                                kousky masa nebo šunky.
                            </div>
                        </li>
                        <li>
                            <div>2.</div>
                            <div>Tohle totiž není první případ, který tady ve Žďáře řeším.</div>
                        </li>
                        <li>
                            <div>5.</div>
                            <div>
                                Řekl jsem si, že jim pomůžu. Číhal jsem u kontejnerů na písek celou noc, až mě zábly
                                tlapky.
                            </div>
                        </li>
                        <li>
                            <div>4.</div>
                            <div>
                                Všem to tady hrozně klouzalo. Vyjít ten kopec až sem bylo pro lidi, co tu pracovali,
                                skoro nemožné. Jak jsem tu jednou šel na obchůzku, tak jsem si všiml, jak se tu kloužou
                                a válí.
                            </div>
                        </li>
                    </ol>
                </div>
                <div className="zdar-cipher-text zdar-butcher-cipher-heading">9-10, 2-10, 4-13, 3-26</div>
                <div className="zdar-cipher-text zdar-butcher-cipher-heading">8-29, 9-19, 6-26, 9-33</div>
                <div className="zdar-cipher-text zdar-butcher-cipher-heading">7-9, 1-20, 5-3</div>
            </div>
        </React.Fragment>
    );
}
